export default {
  trigger: 'Invita il proprietario del ristorante',
  title: 'Invita il proprietario del ristorante',
  description:
    "Crea un account per il proprietario del ristorante. Riceverà un'email con una password temporanea per accedere e completare la configurazione.",
  fields: {
    first_name: 'Nome',
    last_name: 'Cognome',
    email: 'Email',
  },
  buttons: {
    invite: 'Invia invito',
    cancel: 'Annulla',
  },
  toasts: {
    invited: '{{email}} è stato invitato a completare la configurazione.',
    failed: "Impossibile creare l'account del proprietario. Riprova.",
  },
};
